function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import KZUIComponent from '../base';
import Button from '../Button';
import Popover from '../Popover';
import './style.less';

var Popconfirm = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(Popconfirm, _KZUIComponent);

  var _super = _createSuper(Popconfirm);

  function Popconfirm(props) {
    var _this;

    _classCallCheck(this, Popconfirm);

    _this = _super.call(this, props);

    _this.autoBind('handleConfirm', 'handleCancel', 'handleBlur', 'handleClick');

    return _this;
  }

  _createClass(Popconfirm, [{
    key: "handleConfirm",
    value: function handleConfirm(e) {
      if (this.props.onConfirm) {
        this.props.onConfirm(e);
      }

      this.popover.hide();
    }
  }, {
    key: "handleCancel",
    value: function handleCancel(e) {
      if (this.props.onCancel) {
        this.props.onCancel(e);
      }

      this.popover.hide();
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      if (!this.popConfirm.contains(e.target)) {
        if (this.props.onBlur) {
          this.props.onBlur(e);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var clsPrefix = 'kui-popconfirm';
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          children = _this$props.children,
          title = _this$props.title;
      var cls = classNames(clsPrefix, className);
      var confirmContent = /*#__PURE__*/React.createElement("div", {
        className: cls,
        style: style
      }, /*#__PURE__*/React.createElement("div", null, title), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--btns")
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.handleCancel,
        className: "".concat(clsPrefix, "--cancel")
      }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement(Button, {
        size: "small",
        type: "primary",
        onClick: this.handleConfirm
      }, "\u786E\u8BA4")));
      return /*#__PURE__*/React.createElement(Popover, {
        content: confirmContent,
        trigger: "click",
        ref: function ref(popover) {
          _this2.popover = popover;
        }
      }, children);
    }
  }]);

  return Popconfirm;
}(KZUIComponent);

Popconfirm.defaultProps = {
  hide: true,
  onBlur: null,
  onCancel: null,
  onConfirm: null,
  status: 'normal'
};
Popconfirm.propTypes = {
  hide: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  onBlur: PropTypes.func,
  status: PropTypes.oneOf(['normal', 'loading']),
  title: PropTypes.string.isRequired
};
export default Popconfirm;